import { Heading } from '@everlywell/ui-kit';
import React from 'react';

export interface FormTitleProps {
  mainHeading: string;
  secondaryHeading: string;
}

/**
 * This component adds the form title to the pre-purchase quiz modal.
 */
function FormTitle({
  mainHeading,
  secondaryHeading,
}: FormTitleProps): JSX.Element {
  return (
    <>
      <Heading as="h1" size="xl" color="tints.uiGrey" opacity="0.6">
        {mainHeading}
      </Heading>
      <Heading as="h2" size="xl">
        {secondaryHeading}
      </Heading>
    </>
  );
}

export default FormTitle;
